// extracted by mini-css-extract-plugin
export default {"flex":"BusinessDetail_flex__P9hWo","flexAndSpaceBetween":"BusinessDetail_flexAndSpaceBetween__E15IH"};